.fp-vertical-spacing.-s-xs
  .fp-vertical-spacing--line
    MediasInputVue(:medias='medias' :touched='touched' :accept='[MediaType.IMAGE]' :required='required' @updated-medias='updatedMedias => updateMedia(updatedMedias.value)' @unsupported-files='fileCount => setUnsupportedFileCount(fileCount.value > 0)')
  .fp-vertical-spacing--line(v-if='unsupportedFile' data-test='unsupported-media')
    span.fp-text.-color-danger {{ t('mediaInput.unsupportedMedia') }}
